module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAAAMCAYAAACZW2gkAAAAAXNSR0IArs4c6QAAAM9JREFUWAljYMACbt26lfjq1SseLFKjQjQKASZ0c2/evNnw79+/ee/fv98+GhnooUM7PiOy0aBI+P//fz1MjJGR8YigoKCnmJjYF5jYKE2bEIBHBHokwKwbjQxYSNCWBkcErkiAWT0aGbCQoB3NSCgSYFYDI+MhkL0UiH/BxEZpykOAiYnpgKqq6kGMyppyo0dNICcERosmckKNBnpGK2saBCo5RsIjAqQZvb4YraTJCVIq6QFFxo0bN/4D6cOjHToqBSq5xowOcZAbcuTrAwAmimYZNd9uCQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/info_right.png
// module id = Yqsg
// module chunks = 1